import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ActionButton,
  Checkbox,
  CheckboxVisibility,
  DefaultButton,
  DetailsList,
  Dropdown,
  IColumn,
  IContextualMenuItem,
  IDetailsRowProps,
  Label,
  Modal,
  Pivot,
  PivotItem,
  PrimaryButton,
  Stack,
  TextField,
  mergeStyleSets,
} from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { commonfn } from '../../../../common/commonfn';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
import { DialogContext } from '../../../../context/dialog.context';
import { defaultTheme } from '../../../../common/constant/theme';
import { _renderRow } from '../../../../control/function/detailList';
import ButtonMenuContext from '../../../../control/ButtonMenuContext';
import ModalAddUsersToVendor from '../modal/modalAddUsersToVendor';
import ModalUser from '../../users/modal/modalUser';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { useId } from '@fluentui/react-hooks';
import { css } from '@fluentui/react/lib/Utilities';

const classNames = mergeStyleSets({
  overflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 200,
  },
  parent: {
    padding: 5,
  },
});

export interface ModaComponentProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item?: Api.Vendor | null;
  ProductType: number;
}
const ProductTypesApi = new Api.ProductTypesApi();
const VendorsApi = new Api.VendorsApi();
const ModalVendor = ({ onSaveClick, Item, IsOpen, onCloseModal, ProductType }: ModaComponentProps) => {
  const { setMsgConfirmDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  const [isShow, SetIsShow] = React.useState(false);
  const [isShowAddModal, SetIsShowAddModal] = React.useState(false);
  const [isShowNewModal, SetIsShowNewModal] = React.useState(false);
  const [detail, SetDetail] = React.useState<Api.Vendor>({});
  const [nameErrorMessage, SetNameErrorMessage] = React.useState('');
  const [productTypeErrorMessage, SetProductTypeErrorMessage] = React.useState('');
  const [ErrorMessageContact, SetErrorMessageContact] = React.useState<
    {
      Field: string;
      Error: string;
      obj: Api.ContactVendor;
    }[]
  >([]);
  const [listProductType, setListProductType] = React.useState<any[]>([]);
  const [listProductTypeDB, setListProductTypeDB] = React.useState<Api.ProductType[]>([]);
  const [keyProductTypeSelected, setKeyProductTypeSelected] = React.useState<number[]>([]);
  const { setToastData } = React.useContext(ToastAppMsgContext);
  const { t } = useTranslation();
  const getTitle = (): string => {
    if (Item) {
      return t('EditVendor');
    }
    return t('NewVendor');
  };
  const [tabKey, SetTabKey] = React.useState<string>("General");
  const [userList, SetUserList] = React.useState<Api.UserDto[]>([]);

  const parentTooltipId = useId('text-tooltip');
  const [isParentTooltipVisible, setIsParentTooltipVisible] = React.useState(false);

  const _columns = [
    {
      key: 'action',
      name: '',
      isResizable: true,
      minWidth: 20,
      maxWidth: 20,
      onRender: (item: Api.UserDto) => {
        let menuItems: IContextualMenuItem[] = [
          {
            key: 'Delete',
            text: t('Delete'),
            onClick: (ev) => {
              setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
              setCallBackConfirmDialog({ action: deleteItem, param: item.Id });
              console.log(item.Id);
            },
          },
        ];
        return <ButtonMenuContext ClassName={'menuContextDefault'} MenuItems={menuItems} IconName={'MoreVertical'} />;
      },
    },
    {
      key: 'Name',
      name: t('VendorName'),
      minWidth: 200,
      fieldName: 'FullName',
      isResizable: true,
      className: 'flex-center',
    },
    {
      key: 'Email',
      name: t('Email'),
      minWidth: 200,
      fieldName: 'Email',
      isResizable: true,
      className: 'flex-center',
      onRender: (item: Api.UserDto) => {
        return <div className={css(classNames.parent, classNames.overflow)}>
          <TooltipHost
            overflowMode={TooltipOverflowMode.Parent}
            content={item.Email ?? ''}
            onTooltipToggle={setIsParentTooltipVisible}
            id={parentTooltipId}
          >
            <span aria-describedby={isParentTooltipVisible ? parentTooltipId : undefined}>{item.Email}</span>
          </TooltipHost>
        </div>
      }
    },
    {
      key: 'Company',
      name: t('Company'),
      fieldName: 'Company',
      minWidth: 200,
      isResizable: true,
      className: 'flex-center',
      onRender: (item: Api.UserDto) => {
        return <div className={css(classNames.parent, classNames.overflow)}>
        <TooltipHost
          overflowMode={TooltipOverflowMode.Parent}
          content={item.Company ?? ''}
          onTooltipToggle={setIsParentTooltipVisible}
          id={parentTooltipId}
        >
          <span aria-describedby={isParentTooltipVisible ? parentTooltipId : undefined}>{item.Company}</span>
        </TooltipHost>
      </div>
      }
    }
  ] as IColumn[];

  const deleteItem = async (id: number) => {
    let data = {
      VendorId: Item?.Id,
      UserId: id
    } as Api.UserVendorModel;
    await VendorsApi.apiVendorsRemoveUserPost(data);
    await getUserList();
  };

  React.useEffect(() => {
    SetIsShow(IsOpen);
    if (IsOpen) {
      getAllProductTypes();
      if (Item == null) {
        var newdetail = { States: Api.StatesEnum.Active } as Api.Vendor;
        newdetail.ContactVendors = new Array<Api.ContactVendor>();
        newdetail?.ContactVendors?.push({
          Email: '',
          PhoneNumber: '',
          Name: '',
        } as Api.ContactVendor);
        SetDetail(newdetail);
      } else {
        getItemData();
      }
    } else {
      setTimeout(() => {
        SetDetail({ States: Api.StatesEnum.Active });
        setKeyProductTypeSelected([]);
      }, 200);
    }
    SetNameErrorMessage('');
    SetErrorMessageContact([]);
  }, [IsOpen]);
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const getItemData = async () => {
    var data = (await VendorsApi.apiVendorsIdGet(Item?.Id || 0)).data;
    SetDetail(data.Data || { States: Api.StatesEnum.Active });
    if (data.Data) {
      setKeyProductTypeSelected((data.Data?.ProductTypes?.map((o) => o.Id) || []) as number[]);
    }
  };

  const getUserList = async () => {
    var data = (await VendorsApi.apiVendorsGetUsersIdGet(Item?.Id || 0)).data;
    SetUserList(data);
  };

  const addContactVendor = () => {
    if (!detail?.ContactVendors) {
      detail.ContactVendors = new Array<Api.ContactVendor>();
    }
    detail?.ContactVendors?.push({
      Email: '',
      PhoneNumber: '',
      Name: '',
    } as Api.ContactVendor);
    SetDetail({ ...detail });
  };
  const deleteContactVendor = (contactVendor: Api.ContactVendor) => {
    detail.ContactVendors = detail?.ContactVendors?.filter((o) => o !== contactVendor) || [];
    SetDetail({ ...detail });
  };
  const validateFormData = () => {
    let pass = true;
    if (!detail.Name) {
      SetNameErrorMessage(t('VendorNameIsRequired'));
      pass = false;
    }
    if ((detail.ProductTypes?.length || 0) === 0) {
      SetProductTypeErrorMessage(t('IsRequired').replace('{0}', t('ProductType')));
      pass = false;
    }
    if (detail.ContactVendors) {
      let errorMessages: any[] = [];
      detail.ContactVendors.forEach((o, i) => {
        if (!o.Name || o.Name?.trim().length === 0) {
          var error = {
            Error: t('NameIsRequired'),
            Field: 'Name',
            obj: o,
          };
          errorMessages.push(error);
        }
        if (!o.Email || o.Email?.trim().length === 0) {
          var error1 = {
            Error: t('EmailIsRequired'),
            Field: 'Email',
            obj: o,
          };
          errorMessages.push(error1);
        } else if (!commonfn.validateEmail(o?.Email)) {
          var error2 = {
            Error: t('InvalidEmailAddress'),
            Field: 'Email',
            obj: o,
          };
          errorMessages.push(error2);
        }
      });
      if (errorMessages.length > 0) {
        SetErrorMessageContact(errorMessages);
        pass = false;
      }
    }
    return pass;
  };
  const onSave = async () => {
    if (!validateFormData()) {
      return;
    }
    var data = await VendorsApi.apiVendorsPost({ Model: detail });
    if (!data || data.status !== 200) return;
    setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
    onCloseModal();
    SetIsShow(false);
    if (onSaveClick) {
      onSaveClick();
    }
  };

  const getAllProductTypes = async () => {
    if (listProductType.length > 0) return;
    let data = (
      await ProductTypesApi.apiProductTypesPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let productTypes: any[] = [];
    data.Data?.forEach((element) => {
      productTypes.push({ key: element.Id, text: element.Name });
    });
    if (!productTypes.length) {
      productTypes.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListProductType(productTypes);
    setListProductTypeDB(data.Data || []);
  };
  return (
    <>
      {isShowAddModal && (
        <ModalAddUsersToVendor
          IsOpen={isShowAddModal}
          Item={Item?.Id}
          onSaveClick={async () => {
            SetIsShowAddModal(false);
            await getUserList();
            SetIsShow(true);
          }}
          onCloseModal={() => {
            SetIsShowAddModal(false);
            SetIsShow(true);
          }}
        ></ModalAddUsersToVendor>
      )}

      {isShowNewModal && (
        <ModalUser
          IsOpen={isShowNewModal}
          Item={null}
          VendorId={Item?.Id}
          onSaveClick={async () => {
            SetIsShowNewModal(false);
            await getUserList();
            SetIsShow(true);
          }}
          onCloseModal={() => {
            SetIsShowNewModal(false);
            SetIsShow(true);
          }}
        ></ModalUser>
      )}
      
      <Modal isOpen={isShow} isModeless={true}>
        <ModalHeader
          title={getTitle()}
          onCloseModal={() => {
            onClose();
          }}
        />
        <Pivot className="tab-header" style={{ overflow: 'hidden' }} selectedKey={tabKey} onLinkClick={(item, e) => {
          SetTabKey(item?.props.itemKey || "General")
          if (item?.props.itemKey === 'Users') {
            getUserList();
          }
        }}
          overflowBehavior={'menu'}>

          <PivotItem headerText={t('General')} key={"General"} itemKey={"General"} >
            <div className={'modal-content'} style={{ width: 700 }}>
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
                    <TextField
                      label={t('VendorName') + ' (*)'}
                      errorMessage={nameErrorMessage}
                      value={detail?.Name || ''}
                      onChange={(e, newValue) => {
                        SetDetail({ ...detail, Name: newValue });
                        SetNameErrorMessage('');
                      }}
                    ></TextField>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-md12  padding-left-0 padding-right-0 ms-Grid-col">
                    <TextField
                      label={t('Address')}
                      value={detail?.Address || ''}
                      onChange={(e, newValue) => {
                        SetDetail({ ...detail, Address: newValue });
                      }}
                    ></TextField>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-md12 ms-Grid-col  padding-left-0 padding-right-0 margin-bottom-0">
                    <Dropdown
                      label={t('ProductType') + ' (*)'}
                      options={listProductType}
                      errorMessage={productTypeErrorMessage}
                      placeholder={t('SelectProductTypes')}
                      multiSelect
                      selectedKeys={keyProductTypeSelected}
                      onChange={(e, option) => {
                        if (listProductType && option?.key) {
                          if (option.selected) {
                            if (!detail.ProductTypes) {
                              detail.ProductTypes = [];
                            }
                            if (!detail.ProductTypes.find((o) => o.Id === option?.key)) {
                              let item = listProductTypeDB.find((o) => o.Id === option?.key);
                              if (item) {
                                detail.ProductTypes?.push(item);
                              }
                            }
                          } else {
                            detail.ProductTypes = detail.ProductTypes?.filter((o) => o.Id !== option?.key);
                          }
                          SetDetail({ ...detail });
                          setKeyProductTypeSelected((detail.ProductTypes?.map((o) => o.Id) || []) as number[]);
                          SetProductTypeErrorMessage('');
                        }
                      }}
                    ></Dropdown>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
                    <Checkbox
                      label={t('Active')}
                      checked={detail?.States === Api.StatesEnum.Active ? true : false}
                      onChange={(e, checked) => {
                        SetDetail({ ...detail, States: checked ? Api.StatesEnum.Active : Api.StatesEnum.Inactive });
                      }}
                    ></Checkbox>
                  </div>
                </div>
                <Stack
                  className="ms-Grid-row"
                  style={{ maxHeight: 400, overflowY: 'auto', overflowX: 'hidden', padding: '0 10px' }}
                >
                  {detail?.ContactVendors?.map((o, i) => {
                    return (
                      <React.Fragment key={i}>
                        <div className="ms-Grid-row">
                          <div
                            className=" ms-md12 ms-Grid-col margin-0 padding-left-0 ms-Grid-row"
                            style={{ display: 'flex' }}
                          >
                            <div style={{ marginRight: 15, justifyContent: 'center', display: 'flex' }}>
                              <Label style={{ margin: 'auto' }}>{t('ContactPerson') + ' ' + (i + 1)}</Label>
                            </div>
                            <div style={{ flex: 1, justifyContent: 'center', display: 'flex' }}>
                              <div style={{ background: '#ddd', height: 1, width: '100%', margin: 'auto' }}></div>
                            </div>
                            {(detail?.ContactVendors?.length || 0) > 1 && (
                              <div style={{ marginLeft: 15, justifyContent: 'center', display: 'flex' }}>
                                <ActionButton
                                  iconProps={{ iconName: 'Delete' }}
                                  styles={{
                                    icon: { color: defaultTheme.palette.red },
                                    root: {
                                      color: defaultTheme.palette.red,
                                      selectors: {
                                        ':hover .ms-Button-textContainer,:hover .ms-Icon': {
                                          color: defaultTheme.palette.red + '!important',
                                        },
                                      },
                                    },
                                  }}
                                  onClick={() => {
                                    setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
                                    setCallBackConfirmDialog({ action: deleteContactVendor, param: o });
                                  }}
                                >
                                  {t('Remove')}
                                </ActionButton>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div className="ms-md12 ms-Grid-col  padding-left-0 padding-right-0">
                            <TextField
                              label={t('Name') + ' (*)'}
                              errorMessage={ErrorMessageContact.find((er) => er.obj === o && er.Field === 'Name')?.Error}
                              value={o?.Name || ''}
                              onChange={(e, newValue) => {
                                o.Name = newValue;
                                SetDetail({ ...detail });
                                var err = ErrorMessageContact.find((er) => er.obj === o && er.Field === 'Name');
                                if (err) {
                                  err.Error = '';
                                  SetErrorMessageContact([...ErrorMessageContact]);
                                }
                              }}
                            ></TextField>
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div className="ms-md6 ms-Grid-col  padding-left-0 ">
                            <TextField
                              label={t('Email') + ' (*)'}
                              errorMessage={ErrorMessageContact.find((er) => er.obj === o && er.Field === 'Email')?.Error}
                              value={o?.Email || ''}
                              onChange={(e, newValue) => {
                                o.Email = newValue;
                                SetDetail({ ...detail });
                                var err = ErrorMessageContact.find((er) => er.obj === o && er.Field === 'Email');
                                if (err) {
                                  err.Error = '';
                                  SetErrorMessageContact([...ErrorMessageContact]);
                                }
                              }}
                            ></TextField>
                          </div>
                          <div className="ms-md6 ms-Grid-col  padding-right-0">
                            <TextField
                              label={t('PhoneNumber')}
                              value={o?.PhoneNumber || ''}
                              onChange={(e, newValue) => {
                                o.PhoneNumber = newValue;
                                SetDetail({ ...detail });
                              }}
                            ></TextField>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </Stack>
                <div className="ms-Grid-row">
                  <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
                    <ActionButton
                      iconProps={{ iconName: 'AddFriend' }}
                      styles={{
                        root: {
                          color: defaultTheme.palette.themePrimary,
                          selectors: {
                            ':hover .ms-Button-textContainer,:hover .ms-Icon': {
                              color: defaultTheme.palette.themePrimary,
                            },
                          },
                        },
                      }}
                      onClick={addContactVendor}
                    >
                      {t('AddContact')}
                    </ActionButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={'modal-footer'}>
              <DefaultButton
                onClick={() => {
                  onClose();
                }}
                className={'margin-left-10'}
              >
                {t('Close')}
              </DefaultButton>
              <PrimaryButton
                className={'margin-left-10'}
                onClick={() => {
                  onSave();
                }}
              >
                {t('Save')}
              </PrimaryButton>
            </div>
          </PivotItem>
          {Item && (<PivotItem headerText={t('Users')} key={"Users"} itemKey={"Users"} >
            <div className={'modal-content'} style={{ width: 700 }}>
              <div className="ms-Grid" dir="ltr">
                <div style={{ textAlign: 'right' }}>
                  <DefaultButton
                    className={'margin-left-10'}
                    onClick={() => {
                      SetIsShow(false);
                      SetIsShowAddModal(true);
                    }}
                  >
                    {t('Add')}
                  </DefaultButton>
                  <DefaultButton
                    className={'margin-left-10'}
                    onClick={() => {
                      SetIsShow(false);
                      SetIsShowNewModal(true);
                    }}
                  >
                    {t('New')}
                  </DefaultButton>
                </div>
                <div className="ms-Grid-row">
                  {(userList?.length || 0) > 0 && (
                    <DetailsList
                      items={userList || []}
                      columns={_columns}
                      checkboxVisibility={CheckboxVisibility.hidden}
                      onShouldVirtualize={() => false}
                      onRenderRow={(props) => {
                        return _renderRow(props || ({} as IDetailsRowProps), () => {
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </PivotItem>
          )}
        </Pivot>
      </Modal>
    </>
  );
};
export default ModalVendor;
